import styled from '@emotion/styled'
import dynamic from 'next/dynamic'
import { memo } from 'react'
import { FloaterModal, generateModalKey } from '../../../state/modals'
import { useLayoutSelector } from '../../Hooks/useLayout'
import { useFloaters, useFloatingRoomId } from '../../Hooks/useModal'
import { usePassive } from '../../Hooks/usePassive'
import { useRouteSelector } from '../../Hooks/useRoute'
import { useScreenStateSelector } from '../../Hooks/useScreenState'
import { palette } from '../../styles/colors'
import { PAPER_HEIGHTS } from '../../theme'

// const roomPromise = import('../Modals/FullscreenFloater')
// const FullscreenFloater = dynamic(() => roomPromise)
const floaterPromise = import('../Modals/Floater')
const Floater = dynamic(() => floaterPromise)
const quickMenuPromise = import('../Modals/QuickMenu')
const QuickMenu = dynamic(() => quickMenuPromise)

interface FloaterLayoutProps {
    isMobile: boolean
}
const TransitionCover = styled('div')({
    position: 'absolute',
    background: palette.background,
    width: '100%',
    height: '100%',
    zIndex: PAPER_HEIGHTS.fullWindowVideo,
})
const Floaters = (props: FloaterLayoutProps) => {
    const { isMobile } = props
    const floaters = useFloaters()
    const floatingRoomId = useFloatingRoomId()
    const calculated = useScreenStateSelector('calculated')
    const portrait = useScreenStateSelector('portrait')
    const fullWindow = useLayoutSelector('fullWindow')
    const passiveMode = usePassive()
    const FloatingPage = useRouteSelector('floatingComponent')
    // TODO: it may be possible to get rid of the floating_room modal object?
    // const floatingRoomId = useRouteSelector('slugID')
    return (
        <>
            {floatingRoomId && passiveMode && fullWindow && (
                <TransitionCover id="transition-cover" />
            )}
            {floaters.map((floater: FloaterModal) => (
                <Floater
                    vertical={portrait}
                    fullWindow={fullWindow}
                    isMobile={isMobile}
                    floaterType={floater.type}
                    floaterID={floater.state.id}
                    key={generateModalKey(floater.type, floater.state.id)}
                />
            ))}
            {floatingRoomId && calculated && (
                <FloatingPage
                    fullWindow={fullWindow}
                    isMobile={isMobile}
                    vertical={portrait}
                />
            )}
            <QuickMenu />
        </>
    )
}

export default memo(Floaters)
